import { EyeIcon } from "@heroicons/react/24/outline";
import { IconButton } from "../../../../../../../components/ui";

const Actions = props => {
  const { id } = props || {};

  if (typeof id == "number") {
    return (
      <div className="user-list-actions flex text-right text-sm font-medium">
        {id && (
          <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4">
            <IconButton variant="clean" title="View Document">
              <EyeIcon
                className={`h-4 w-4 cursor-pointer text-gray-400`}
                onClick={() => {
                  window.open(`/consignment/${id}/form`, "_blank");
                }}
              />
            </IconButton>
          </div>
        )}
      </div>
    );
  } else {
    return false;
  }
};

export default Actions;
